import * as React from "react";
const SvgFiRrDeposit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-deposit_svg__a)">
      <path
        fill="#062147"
        d="M23 18h-2.998a4.01 4.01 0 0 1-2.944-1.292l-2.804-3.047a.997.997 0 0 1 .077-1.406c.368-.328.928-.337 1.255-.066l2.721 2.616a1 1 0 1 0 1.386-1.442l-2.771-2.661A3 3 0 0 0 15 10.007V9.001q-.001-.514-.101-1h2.928c1.167 0 2.304.412 3.201 1.159l1.331 1.109a1 1 0 1 0 1.281-1.536l-1.331-1.11a7.02 7.02 0 0 0-4.481-1.622h-3.83a5 5 0 0 0-3.997-2h-2A4.006 4.006 0 0 0 4 0C1.794 0 0 1.794 0 4v16c0 2.206 1.794 4 4 4s4-1.794 4-4h2a5.01 5.01 0 0 0 4.591-3.02l.996 1.082A6.01 6.01 0 0 0 20.003 20h2.998A1 1 0 1 0 23 18M4 2c1.103 0 2 .897 2 2H2c0-1.103.897-2 2-2m-2 8c1.103 0 2 .897 2 2s-.897 2-2 2zm2 12c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2m6-4H2v-2c2.206 0 4-1.794 4-4S4.206 8 2 8V6h8c1.654 0 3 1.346 3 3v1.762l-.003.003a3.003 3.003 0 0 0-.223 4.241l.216.235A3.003 3.003 0 0 1 10 18m1-8.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 11 9.5m0 5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 11 14.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-deposit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDeposit;
